import script from "./video.vue?vue&type=script&lang=ts&setup=true"
export * from "./video.vue?vue&type=script&lang=ts&setup=true"

import "./video.vue?vue&type=style&index=0&id=9540154a&lang=scss"

const __exports__ = script;

export default __exports__